import { useCallback, useEffect, useRef, useState } from "react";
import * as d3 from "d3";

export default function Area({
  xScale,
  yScale,
  xAccessor,
  yAccessor,
  dotRaduis,
  color,
  borderColor,
  index,
  data,
  anchorEl,
  tooltipEl
}: any) {
  const lineRef = useRef(null);
  const areaRef = useRef(null);
  const dotGroupRef = useRef(null);
  // const tooltipRef = useRef(null);
  const [isMounted, setIsMounted] = useState(false);

  const line = useCallback((delta: number) =>
    d3
      .line()
      .x((d: any) => xScale(xAccessor(d)))
      .y((d: any) => {
        const value = yScale(yAccessor(d)) + delta;
        return value > yScale(yScale.domain()[0])
          ? yScale(yScale.domain()[0])
          : value;
      }),
    [xScale, yScale, xAccessor, yAccessor]);

  const area = useCallback(
    (delta: number) => // delta is for the animation.
      d3
        .area()
        .x((d: any) => xScale(xAccessor(d)))
        .y1((d: any) => {
          const value = yScale(yAccessor(d)) + delta;
          return value > yScale(yScale.domain()[0])
            ? yScale(yScale.domain()[0])
            : value;
        })
        .y0(() => yScale(yScale.domain()[0])),
    [xScale, yScale, xAccessor, yAccessor]
  );

  useEffect(() => {

    if(!isMounted && anchorEl){
      d3.select(areaRef.current)
        .attr("d", area(100)(data))
        .transition()
        .duration(1000)
        .ease(d3.easeQuadOut)
        .attr("d", area(0)(data));

      d3.select(lineRef.current)
        .attr("d", line(100)(data))
        .transition()
        .duration(1000)
        .ease(d3.easeQuadOut)
        .attr("d", line(0)(data));

      setIsMounted(true);
    }
    else if(isMounted){
      d3.select(areaRef.current).attr("d", area(0)(data));
      d3.select(lineRef.current).attr("d", line(0)(data));
    }
  }, [data, line, area, anchorEl, tooltipEl, borderColor, dotRaduis, index, xScale, yScale, isMounted]);

  return (
    <g>
      <path ref={lineRef} stroke={borderColor} fill="none" />
      <path ref={areaRef} fill={`url(#gradient-${color})`} />
      <defs>
        <linearGradient
          id={`gradient-${color}`}
          x1="0%"
          x2="0%"
          y1="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor={color} stopOpacity={0.2} />
          <stop offset="40%" stopColor={color} stopOpacity={0.2} />
          <stop offset="100%" stopColor={color} stopOpacity={0} />
        </linearGradient>
      </defs>
      <g ref={dotGroupRef} />
    </g>
  );
}
